import { useState } from "react";
import { Carousel } from "antd";
import { useMediaQuery } from "react-responsive";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import Marquee from "react-fast-marquee";

const FlipReviewGrid = () => {
  // Initializing an array of states for the 6 cards
  const [flippedStates, setFlippedStates] = useState(Array(6).fill(false));

  // Function to handle flip, takes an index to know which card to flip
  const handleFlip = (index: number) => {
    const newFlippedStates = [...flippedStates];
    newFlippedStates[index] = !newFlippedStates[index];
    setFlippedStates(newFlippedStates);
  };

  // Media query to detect mobile screen
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

  const renderFlipCard = (index: number, frontContent: JSX.Element) => (
    <div className="flipper">
      <div
        className={`flipper-card ${
          flippedStates[index] ? "flipper-is-flipped" : ""
        }`}
      >
        <div className="flipper-front">{frontContent}</div>
      </div>
    </div>
  );

  const cardData = [
    {
      index: 0,
      frontContent: (
        <div className="review-flip-card">
          <div className="reviewImage">
            <img
              loading="lazy"
              src="/assets/images/testimonial/working/1.webp"
              alt="card"
            />
          </div>
          <div className="p-2">
            <div className="clientDetails">
              <img
                loading="lazy"
                src="/assets/images/testimonial/people/7.webp"
                alt=""
              />
              <div>
                <span className="name">Revell M.</span>
                <span className="designation">Real estate agent</span>
                <span className="country">Rimini, Italy</span>
              </div>
            </div>
            <div className="reviewText">
              Working with Stagobox has been a game-changer for my real estate
              listings. Their virtual renovation services allow my clients to
              see the full potential of a property before ever setting foot
              inside. Whether it's transforming an outdated kitchen or giving a
              tired living room a modern facelift, their attention to detail and
              photorealistic results have consistently impressed both buyers and
              sellers.
            </div>
          </div>
        </div>
      ),
    },
    {
      index: 1,
      frontContent: (
        <div className="review-flip-card">
          <div className="reviewImage">
            <img
              loading="lazy"
              src="/assets/images/testimonial/working/2.webp"
              alt="card"
            />
          </div>
          <div className="p-2">
            <div className="clientDetails">
              <img
                loading="lazy"
                src="/assets/images/testimonial/people/5.webp"
                alt=""
              />
              <div>
                <span className="name">Patrick B.</span>
                <span className="designation">Real estate agent</span>
                <span className="country">Calgary, Canada</span>
              </div>
            </div>
            <div className="reviewText">
              Stagobox virtual staging service has been a lifesaver for my real
              estate business. Their attention to detail and ability to create
              realistic virtual furniture placements have significantly enhanced
              the appeal of my listings.tagobox virtual staging service has been
              a lifesaver for my real estate business. Their attention to detail
              and ability to create realistic virtual furniture placements have
              significantly enhanced the appeal of my listings.
            </div>
          </div>
        </div>
      ),
    },
    {
      index: 2,
      frontContent: (
        <div className="review-flip-card">
          <div className="reviewImage">
            <img
              loading="lazy"
              src="/assets/images/testimonial/working/3.webp"
              alt="card"
            />
          </div>
          <div className="p-2">
            <div className="clientDetails">
              <img
                loading="lazy"
                src="/assets/images/testimonial/people/16.webp"
                alt=""
              />
              <div>
                <span className="name">John D.</span>
                <span className="designation">Real Estate Agent</span>
                <span className="country">Texas, USA</span>
              </div>
            </div>
            <div className="reviewText">
              I've tried several virtual staging companies, but Stagobox is in a
              league of their own. When I sent them photos of a vacant condo on
              Monday morning, they delivered fully staged images by Tuesday -
              complete with modern furniture and perfect decor accents. The
              quality was so good that three different buyers asked if we were
              including the furnishings! This listing went under contract in 9
              days, and I credit Stagobox's realistic staging for creating that
              emotional connection with buyers.
            </div>
          </div>
        </div>
      ),
    },
    {
      index: 3,
      frontContent: (
        <div className="review-flip-card">
          <div className="reviewImage">
            <img
              loading="lazy"
              src="/assets/images/testimonial/working/4.webp"
              alt="card"
            />
          </div>
          <div className="p-2">
            <div className="clientDetails">
              <img
                loading="lazy"
                src="/assets/images/testimonial/people/14.webp"
                alt=""
              />
              <div>
                <span className="name">Sarah M.</span>
                <span className="designation">Property Developer</span>
                <span className="country">London, UK</span>
              </div>
            </div>
            <div className="reviewText">
              What impressed me most was how Stagobox handled our bulk order for
              12 property images. Despite the large volume, every single virtual
              renovation was completed within 48 hours with incredible attention
              to detail. The kitchen remodels showed perfect reflections on
              stainless steel appliances, and the bathroom renders included
              realistic tile textures. Their work helped us pre-sell 80% of
              units before construction even finished!
            </div>
          </div>
        </div>
      ),
    },
    {
      index: 4,
      frontContent: (
        <div className="review-flip-card">
          <div className="reviewImage">
            <img
              loading="lazy"
              src="/assets/images/testimonial/working/5.webp"
              alt="card"
            />
          </div>
          <div className="p-2">
            <div className="clientDetails">
              <img
                loading="lazy"
                src="/assets/images/testimonial/people/1.webp"
                alt=""
              />
              <div>
                <span className="name">David T.</span>
                <span className="designation">Real Estate Photographer</span>
                <span className="country">Toronto, Canada</span>
              </div>
            </div>
            <div className="reviewText">
              As a photographer, I'm extremely particular about image quality.
              Stagobox's editing team consistently amazes me - they can turn my
              good photos into spectacular ones overnight. Last week, they
              transformed a poorly lit interior shot into a bright, inviting
              space and even added virtual sunlight streaming through windows.
              My clients keep complimenting the 'magic' I work, but really, it's
              all Stagobox.
            </div>
          </div>
        </div>
      ),
    },
    {
      index: 5,
      frontContent: (
        <div className="review-flip-card">
          <div className="reviewImage">
            <img
              loading="lazy"
              src="/assets/images/testimonial/working/6.webp"
              alt="card"
            />
          </div>
          <div className="p-2">
            <div className="clientDetails">
              <img
                loading="lazy"
                src="/assets/images/testimonial/people/6.webp"
                alt=""
              />
              <div>
                <span className="name">Elena R.</span>
                <span className="designation">Property Manager</span>
                <span className="country">Berlin, Germany</span>
              </div>
            </div>
            <div className="reviewText">
              We manage hundreds of rental units, and Stagobox has become our
              secret weapon. Their virtual staging is so affordable and fast -
              we typically get staged images back within 24 hours. The best
              part? Tenants can't tell the difference between virtually staged
              and real furnished units. Their virtual furniture selections
              perfectly match current design trends, making our properties look
              fresh and modern.
            </div>
          </div>
        </div>
      ),
    },
    {
      index: 6,
      frontContent: (
        <div className="review-flip-card">
          <div className="reviewImage">
            <img
              loading="lazy"
              src="/assets/images/testimonial/working/7.webp"
              alt="card"
            />
          </div>
          <div className="p-2">
            <div className="clientDetails">
              <img
                loading="lazy"
                src="/assets/images/testimonial/people/8.webp"
                alt=""
              />
              <div>
                <span className="name">Michael K.</span>
                <span className="designation">Airbnb Superhost</span>
                <span className="country">California, USA</span>
              </div>
            </div>
            <div className="reviewText">
              When I needed to market my vacation rental, services were
              miracles. They removed all personal items, virtually staged the
              living areas, and even added a deck with a hot tub - all within
              one business day. The images looked so authentic that my first
              guests actually asked where we bought the patio furniture! My
              bookings increased by 60% immediately after using their services.
            </div>
          </div>
        </div>
      ),
    },
    {
      index: 7,
      frontContent: (
        <div className="review-flip-card">
          <div className="reviewImage">
            <img
              loading="lazy"
              src="/assets/images/testimonial/working/8.webp"
              alt="card"
            />
          </div>
          <div className="p-2">
            <div className="clientDetails">
              <img
                loading="lazy"
                src="/assets/images/testimonial/people/3.webp"
                alt=""
              />
              <div>
                <span className="name">Olivia P.</span>
                <span className="designation">Commercial Broker</span>
                <span className="country">Manchester, UK</span>
              </div>
            </div>
            <div className="reviewText">
              Staging empty office spaces used to be a huge expense until I
              found Stagobox. Their virtual office staging is unbelievably
              realistic - down to the computer screens on desks and plants in
              the corners. We recently got a 5,000 sq ft space staged overnight,
              and the quality was so convincing it helped us secure a 5-year
              lease within two weeks.
            </div>
          </div>
        </div>
      ),
    },
    {
      index: 8,
      frontContent: (
        <div className="review-flip-card">
          <div className="reviewImage">
            <img
              loading="lazy"
              src="/assets/images/testimonial/working/9.webp"
              alt="card"
            />
          </div>
          <div className="p-2">
            <div className="clientDetails">
              <img
                loading="lazy"
                src="/assets/images/testimonial/people/9.webp"
                alt=""
              />
              <div>
                <span className="name">James L.</span>
                <span className="designation">House Flipper</span>
                <span className="country">Vancouver, Canada</span>
              </div>
            </div>
            <div className="reviewText">
              I submit properties to Stagobox at all hours, and they never miss
              a deadline. Last month, they completely transformed a rundown
              bungalow into a modern showhome in their virtual renders - new
              floors, updated kitchen, the works. The before-and-after was so
              dramatic that we had multiple offers the first day on market,
              selling for $25K over asking.
            </div>
          </div>
        </div>
      ),
    },
    {
      index: 9,
      frontContent: (
        <div className="review-flip-card">
          <div className="reviewImage">
            <img
              loading="lazy"
              src="/assets/images/testimonial/working/10.webp"
              alt="card"
            />
          </div>
          <div className="p-2">
            <div className="clientDetails">
              <img
                loading="lazy"
                src="/assets/images/testimonial/people/4.webp"
                alt=""
              />
              <div>
                <span className="name">Sophie B.</span>
                <span className="designation">Café Owner</span>
                <span className="country">Paris, France</span>
              </div>
            </div>
            <div className="reviewText">
              Before renovating my café, I worked with Stagobox to visualize
              different layouts. Their team delivered three stunning concepts
              within 36 hours, each with perfect lighting and textures. The
              final renovation matches their virtual staging exactly - right
              down to the copper pendant lights we fell in love with in their
              renderings.
            </div>
          </div>
        </div>
      ),
    },
    {
      index: 10,
      frontContent: (
        <div className="review-flip-card">
          <div className="reviewImage">
            <img
              loading="lazy"
              src="/assets/images/testimonial/working/11.webp"
              alt="card"
            />
          </div>
          <div className="p-2">
            <div className="clientDetails">
              <img
                loading="lazy"
                src="/assets/images/testimonial/people/2.webp"
                alt=""
              />
              <div>
                <span className="name">Robert G.</span>
                <span className="designation">Luxury Specialist</span>
                <span className="country">Miami, USA</span>
              </div>
            </div>
            <div className="reviewText">
              For high-end listings, only the best will do. Stagobox's luxury
              virtual staging is worth every penny. When we added their virtual
              infinity pool and outdoor kitchen to a waterfront listing, the
              images looked so real that our photographer double-checked the
              address! The property sold for full asking price to a buyer who
              specifically mentioned being drawn in by those stunning visuals.
            </div>
          </div>
        </div>
      ),
    },
    {
      index: 11,
      frontContent: (
        <div className="review-flip-card">
          <div className="reviewImage">
            <img
              loading="lazy"
              src="/assets/images/testimonial/working/12.webp"
              alt="card"
            />
          </div>
          <div className="p-2">
            <div className="clientDetails">
              <img
                loading="lazy"
                src="/assets/images/testimonial/people/13.webp"
                alt=""
              />
              <div>
                <span className="name">Julian B.</span>
                <span className="designation">Business Owner</span>
                <span className="country">Eschborn, Germany</span>
              </div>
            </div>
            <div className="reviewText">
              Starting a new business in Germany, I needed professional branding
              to make a strong impression. Stagobox delivered top-notch business
              card designs, vector logos, and eye-catching digital displays.
              Their work was creative, clean, and exactly what I envisioned. I'm
              thrilled with the results and highly recommend them!
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <section
      className="flip-card-section"
      style={{
        background: "linear-gradient(180deg, #FBFCEE,white)",
        marginTop: "0px",
        paddingTop: 140,
      }}
    >
      <div className="container pb-5">
        {!isMobile ? (
          <div className="row g-5 flip-card-container">
            {/* <div className="col-12 col-lg-6 small-flips first"  style={{background:"#f5f5f5", padding:"1rem", marginTop:0, borderRadius:"12px", boxShadow:"0px 0px 12px 2px rgba(0,0,0,0.1)"}}>
              {renderFlipCard(
                cardData[0].index,
                cardData[0].frontContent
              )}
            </div> */}
            <div className="col-12 col-lg-6 trey" style={{ marginTop: 0 }}>
              {/* <Marquee direction="up"> */}
              <div className="row">
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 0,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[0].index, cardData[0].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[1].index, cardData[1].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[2].index, cardData[2].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[3].index, cardData[3].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 0,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[4].index, cardData[4].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[5].index, cardData[5].frontContent)}
                </div>
                {/* copy cards */}
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 0,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[0].index, cardData[0].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[1].index, cardData[1].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[2].index, cardData[2].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[3].index, cardData[3].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 0,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[4].index, cardData[4].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[5].index, cardData[5].frontContent)}
                </div>
              </div>
              {/* </Marquee> */}
            </div>
            <div className="col-12 col-lg-6 trey" style={{ marginTop: 0 }}>
              <div className="row">
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 0,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[6].index, cardData[6].frontContent)}
                </div>

                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[7].index, cardData[7].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[8].index, cardData[8].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[9].index, cardData[9].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 0,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(
                    cardData[10].index,
                    cardData[10].frontContent
                  )}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(
                    cardData[11].index,
                    cardData[11].frontContent
                  )}
                </div>
                {/* copy data start */}
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 0,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[6].index, cardData[6].frontContent)}
                </div>

                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[7].index, cardData[7].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[8].index, cardData[8].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(cardData[9].index, cardData[9].frontContent)}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 0,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(
                    cardData[10].index,
                    cardData[10].frontContent
                  )}
                </div>
                <div
                  className="col-12 small-flips mb-2"
                  style={{
                    background: "#f5f5f5",
                    padding: "1rem",
                    marginTop: 5,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 2px rgba(0,0,0,0.1)",
                  }}
                >
                  {renderFlipCard(
                    cardData[11].index,
                    cardData[11].frontContent
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Carousel
            autoplay
            dots
            arrows
            autoplaySpeed={3000}
            nextArrow={<ArrowRightOutlined />}
            prevArrow={<ArrowLeftOutlined />}
            className="client-rating-slider"
          >
            {cardData.map((card) => (
              <div key={card?.index}>
                {renderFlipCard(card?.index, card.frontContent)}
              </div>
            ))}
          </Carousel>
        )}
      </div>
    </section>
  );
};

export default FlipReviewGrid;
